import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import Constants from '../../../definitions/constants';
import TableDescriptors from '../../../definitions/tableDescriptors';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import FormatTooling from '../../../tooling/formatTooling';
import EntityTableTooling from '../../../tooling/entityTableTooling';
import { intl } from '../../../locales/localesConfig';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import LocaleTooling from '../../../tooling/localeTooling';
import toastr from 'toastr';

/* Actions */
import * as supervisorsAdminRevisionPanelActions from '../../actions/supervisorsAdminRevisionPanel/index';
import * as dashboardActions from '../../actions/dashboard/index';

/*Components*/
import FullScreenGlassLoading from '../../components/common/interface/fullScreenGlassLoading';
import EntityTable from '../../components/common/entity/entityTable';
import GlassConfirmWithNotesPopup from '../../components/common/interface/glassConfirmWithNotesPopup';
import GlassConfirmPopup from '../../components/common/interface/glassConfirmPopup';
import Filters from '../../components/supervisorsAdminRevisionPanel/filters';
import Header from '../../components/supervisorsAdminRevisionPanel/header';
import RevisionsHeader from '../../components/supervisorsAdminRevisionPanel/revisionsHeader';
import RevisionActionsHistoryPopup from '../../components/supervisorsAdminRevisionPanel/revisionActionsHistoryPopup';
import SupervisorActions from '../../components/supervisorRevisionPanel/supervisorActions';

import ErrorLoadingView from '../../components/common/interface/errorLoadingView';

const popupIds = {
  generateRevisionsConfirmPopup: "generateRevisionsConfirmPopup",
  sendMailsConfirmPopup: "sendMailsConfirmPopup",
  revisionActionsHistoryPopup: "revisionActionsHistoryPopup",
  setReviewStatePopup: "setReviewStatePopup",
  setReviewStateConfirmPopup: "setReviewStateConfirmPopup"
}

const initialState = {
  dataFilters: {
    periodIdSelected: "",
    criteria: Constants.selectKeys.supervisor.modelsFilters.ALL,
    modelsSelected: [],
  },
  allRevisionsListFilters: {
    model_revisions_filter: "",
    model_states_filter: "",
  },
  selectedPeriodName: "",
  filtersCollapse: false,
  filtersChanged: true,
  generateRevisionsNotes: "",
  sendMailsNotes: "",
  actionRevisionId: "",
  actionOverrideSupervisorId: "",
  actionRevisionState: "",
  actionModelName: "",
  actionNotes: "",
  actionNewState: "",
  revisionActionsHistoryInfo: null,
};

class SupervisorsAdminRevisionPanel extends Component {
  constructor(props) {
    super(props);
    this.state = JavascriptUtilsTooling.deepCopy(initialState);
  }
 
  async componentDidMount() {    
    await this.props.actions.getPeriodsList();
    await this.props.actions.getModelsList();
  }
  
  componentWillUnmount() {
    this.props.actions.reset();
  }

  componentDidUpdate(prevProps) {      
    InterfaceTooling.apiCallResultFeedback(
      [prevProps.generateRevisions.status],
      [this.props.generateRevisions.status],
      intl.formatMessage({id: "supervisorsAdminRevisionPanel.generateRevisionsSuccess"}),
      this.props.generateRevisions.status==423 ?
        intl.formatMessage({ id: "supervisorsAdminRevisionPanel.systemLockedError" }) :
        intl.formatMessage({ id: "supervisorsAdminRevisionPanel.generateRevisionsError" }),
      [() => {
        if(InterfaceTooling.popupHasToRender(this.state[popupIds.generateRevisionsConfirmPopup])) {
          InterfaceTooling.popupHide(popupIds.generateRevisionsConfirmPopup, this.setState.bind(this));
        }  
      }]
    );

    InterfaceTooling.apiCallResultFeedback(
      [prevProps.sendMails.status],
      [this.props.sendMails.status],
      intl.formatMessage({id: "supervisorsAdminRevisionPanel.sendMailsSuccess"}),
      this.props.sendMails.status==423 ?
        intl.formatMessage({ id: "supervisorsAdminRevisionPanel.systemLockedError" }) :
        intl.formatMessage({ id: "supervisorsAdminRevisionPanel.sendMailsError" }),
      [() => {
        if(InterfaceTooling.popupHasToRender(this.state[popupIds.sendMailsConfirmPopup])) {
          InterfaceTooling.popupHide(popupIds.sendMailsConfirmPopup, this.setState.bind(this));
        }
      }]
    );

    InterfaceTooling.apiCallResultFeedback(
      [prevProps.downloadRevision.status],
      [this.props.downloadRevision.status],
      intl.formatMessage({ id: "supervisorsAdminRevisionPanel.downloadRevisionFileSuccess" }),
      intl.formatMessage({ id: "supervisorsAdminRevisionPanel.downloadRevisionFileFailure" })
    );

    InterfaceTooling.apiCallResultFeedback(
      [prevProps.setRevisionStatus.status],
      [this.props.setRevisionStatus.status],
      intl.formatMessage({id: "supervisorRevisionPanel.revisionActionSuccess"}),
      intl.formatMessage({id: "supervisorRevisionPanel.revisionActionError"}),
      [() => {
        if(InterfaceTooling.popupHasToRender(this.state[popupIds.setReviewStateConfirmPopup])) {
          InterfaceTooling.popupHide(popupIds.setReviewStateConfirmPopup, this.setState.bind(this));
        }
        if(InterfaceTooling.popupHasToRender(this.state[popupIds.setReviewStatePopup])) {
          InterfaceTooling.popupHide(popupIds.setReviewStatePopup, this.setState.bind(this));
        }
        this.props.actions.getRevisionsListByModel(this.getRevisionsListByModelQueryParams(this.state.dataFilters.periodIdSelected));
        this.props.actions.getAllRevisionsList(this.getAllRevisionsListQueryParams(this.state.dataFilters.periodIdSelected));
      }]
    );

    if(this.props.periodsList.status===200 && prevProps.periodsList.status !==200) {
      if(this.props.periodsList.data.length > 0) {
        let periodIdSelected = this.props.periodsList.data[0].id;
        let selectedPeriod = null;
        if(this.props.fixedPeriodId!="") {
          selectedPeriod = this.props.periodsList.data.find(item => item.id==this.props.fixedPeriodId);
          periodIdSelected = selectedPeriod ? selectedPeriod.id : null;
        }
        this.state.dataFilters.periodIdSelected = periodIdSelected;
        this.state.selectedPeriodName = selectedPeriod ? selectedPeriod.name : "";
        this.props.actions.setPeriodId(periodIdSelected);        
        this.props.actions.getRevisionsListByModel(this.getRevisionsListByModelQueryParams(periodIdSelected));
        this.props.actions.getAllRevisionsList(this.getAllRevisionsListQueryParams(periodIdSelected));
      }
    }
  }

  // ==============
  // SUPERVISORS REVISIONS LIST BY MODEL UTILS
  getRevisionsListByModelQueryParams = (periodId) => {
    let queryParams = {
      page: this.props.supervisorsRevisionsListByModel.page,
      per_page: Constants.interface.supervisorRevisionsPageSize,
      period_id: periodId
    };
    return queryParams;
  }

  fetchSupervisorsRevisionsListByModelNextPage = async (event) => {
    var page = +event.currentTarget.dataset.targetpage;
    if(this.props.supervisorsRevisionsListByModel.status === 200 && this.props.supervisorsRevisionsListByModel.page<=this.props.supervisorsRevisionsListByModel.totalPages) {
      await this.props.actions.getRevisionsListByModel(Object.assign(this.getRevisionsListByModelQueryParams(this.state.dataFilters.periodIdSelected), {
        page: page,
      }), true);
    }  
  }
  // ===============

  // ===============
  // ALL REVISIONS LIST UTILS
  getAllRevisionsListQueryParams = (periodId) => {
    let queryParams = {
      page: this.props.allSupervisorsRevisionsList.page,
      per_page: Constants.interface.supervisorRevisionsPageSize,
      period_id: periodId,
      model_revisions_filter: this.state.allRevisionsListFilters.model_revisions_filter,
      model_states_filter: this.state.allRevisionsListFilters.model_states_filter
    };
    return queryParams;
  }

  fetchAllRevisionsListNextPage = async (event) => {
    var page = +event.currentTarget.dataset.targetpage;
    if(this.props.allSupervisorsRevisionsList.status === 200 && this.props.allSupervisorsRevisionsList.page<=this.props.allSupervisorsRevisionsList.totalPages) {
      await this.props.actions.getAllRevisionsList(Object.assign(this.getAllRevisionsListQueryParams(this.state.dataFilters.periodIdSelected), {
        page: page,
      }), true);
    }  
  }
  // ===============
  
  handleFiltersCollapse = (event) => {
    this.setState({
      filtersCollapse: !this.state.filtersCollapse
    });
  };

  handleOnChangePeriod = (event) => {
    let value = event.target.value;
    let newState = JavascriptUtilsTooling.deepCopy(initialState);
    let selectedPeriod = this.props.periodsList.data.find(item => item.id==value);
    newState.dataFilters.periodIdSelected = value;
    newState.selectedPeriodName = selectedPeriod ? selectedPeriod.name : "";
    this.setState(newState);
    this.props.actions.softReset();
    this.props.actions.setPeriodId(newState.dataFilters.periodIdSelected);
    this.props.actions.getModelsList();
    this.props.actions.getRevisionsListByModel(this.getRevisionsListByModelQueryParams(selectedPeriod.id));
    this.props.actions.getAllRevisionsList(this.getAllRevisionsListQueryParams(selectedPeriod.id));
  };
  
  handleOnChangeDataFilters = (event) => {
    let path = event.currentTarget.dataset.path;
    let value = this.state.dataFilters[path];
    let dataFiltersNew = JavascriptUtilsTooling.deepCopy(this.state.dataFilters);
    
    if(event.currentTarget.dataset.selectlist) {
      let index = event.currentTarget.dataset.index;
      let listValue = event.currentTarget.value;
      let isDelete = event.currentTarget.dataset.delete;
      
      let actual_selecteds = dataFiltersNew[path]
            
      if(isDelete) { 
        delete actual_selecteds[index];
        actual_selecteds = actual_selecteds.filter(item => item);
      } else {        
        var selectedItem = this.props.modelsFilter.data.find(item => item.id==listValue);
        var exists = this.state.dataFilters.modelsSelected.find(item => item.id==listValue);
        if(selectedItem && !exists) {
          actual_selecteds.push({id: listValue, name: selectedItem.name });
        }
        else if(exists) {
          toastr.options = Constants.interface.tostrOptions;
          toastr.warning(intl.formatMessage( {id: "supervisorsAdminRevisionPanel.modelAlreadyAdded"}),""); 
        }
      }
      value = actual_selecteds;
    }
    else {
      value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    }
    dataFiltersNew[path] = value;

    if(path=="criteria" && 
      (value==Constants.selectKeys.supervisor.modelsFilters.ALL ||
        value==Constants.selectKeys.supervisor.modelsFilters.ALL_NOT_APPROVED ||
        value==Constants.selectKeys.supervisor.modelsFilters.ALL_NOT_ANSWERED
      )) {
        dataFiltersNew.modelsSelected = [];
    }

    this.setState({
      dataFilters: dataFiltersNew,
      filtersChanged: true,
    });    
  };

  handleFetchFilterModels = async (keyword) => {
    await this.props.actions.getModelsFilteredList(keyword);
  };

  // ============
  // GENERATE REVISIONS
  handleShowGenerateRevisionsConfirmPopup = (event) => {
    InterfaceTooling.handleShowPopup(event, popupIds.generateRevisionsConfirmPopup, 
      this.state, this.setState.bind(this), this.props.generateRevisions.loading, () => {        
        this.setState({
          generateRevisionsNotes: "",
        });
      });
  }

  handleOnClickGenerateRevisionsConfirm = async () => {
    let params = {
      period_id: this.state.dataFilters.periodIdSelected,
      models_criteria: this.state.dataFilters.criteria,
      models: this.state.dataFilters.modelsSelected.map(item => ({id: item.id})),
      admin_message: this.state.generateRevisionsNotes,
    }
    this.props.actions.generateRevisions({
      generate_supervisors_revisions_params: params
    });
  }

  handleOnChangeGenerateRevisionsNotes = (event) => {
    this.setState({
      generateRevisionsNotes: event.currentTarget.value,
    });
  }
  // ============

  // ============
  // MAILS
  handleShowSendMailsConfirmPopup = (event) => {
    InterfaceTooling.handleShowPopup(event, popupIds.sendMailsConfirmPopup, 
      this.state, this.setState.bind(this), this.props.sendMails.loading, () => {        
        this.setState({
          sendMailsNotes: "",
        });
      });
  }

  handleOnClickSendMailsConfirm = async () => {
    let params = {
      period_id: this.state.dataFilters.periodIdSelected,
      models_criteria: this.state.dataFilters.criteria,
      models: this.state.dataFilters.modelsSelected.map(item => ({id: item.id})),
      admin_message: this.state.sendMailsNotes,
    }
    this.props.actions.sendMails({
      send_supervisors_revisions_emails_params: params
    });
  }

  handleOnChangeSendMailsNotes = (event) => {
    this.setState({
      sendMailsNotes: event.currentTarget.value,
    });
  }
  // ============

  // ============
  // ACTIONS
  handleShowActionPopup = (event) => {
    event.stopPropagation();
    InterfaceTooling.handleShowPopup(event, popupIds.setReviewStatePopup, 
      this.state, this.setState.bind(this), this.props.setRevisionStatus.loading, () => {
        let modelRevision = JSON.parse(event.currentTarget.dataset.entitydata);
        this.setState({
          actionRevisionId: modelRevision.revision_id,
          actionOverrideSupervisorId: modelRevision.supervisor_user_id,
          actionRevisionState: modelRevision.revision_state,
          actionModelName: modelRevision.polynomial_name
        });
      });
  }

  handleShowActionConfirmPopup = (event) => {
    InterfaceTooling.handleShowPopup(event, popupIds.setReviewStateConfirmPopup, 
      this.state, this.setState.bind(this), this.props.setRevisionStatus.loading, () => {
        this.setState({
          actionNotes: "",
          actionNewState: event.currentTarget.dataset.action,
        });
      });
  }

  handleOnClickActionConfirm = async () => {
    let params = {
      period_id: this.state.dataFilters.periodIdSelected,
      revision_id: this.state.actionRevisionId,
      supervisor_message: this.state.actionNotes,
      new_revision_state: this.state.actionNewState,
      override_supervisor_id: this.state.actionOverrideSupervisorId
    }
    this.props.actions.setRevisionStatus(params);
  }

  handleOnChangeActionNotes = (event) => {
    this.setState({
      actionNotes: event.currentTarget.value,
    });
  }
  // ============
  
  handleDownloadRevision = async (event) => {
    let revision_object = JSON.parse(event.currentTarget.dataset.entitydata);
    await this.props.actions.downloadRevision({
      revision_id: revision_object.revision_id,
      revision_file_name: revision_object.revision_file_name
    });
  }

  handleViewActionsHistory = async (event) => {
    InterfaceTooling.handleShowPopup(event, popupIds.revisionActionsHistoryPopup, 
      this.state, this.setState.bind(this), false, () => {        
        let revision_object = JSON.parse(event.currentTarget.dataset.entitydata);
        this.setState({
          revisionActionsHistoryInfo: {
            revision_id: revision_object.revision_id,
            polynomial_name: revision_object.polynomial_name,
            supervisor_email: revision_object.supervisor_email
          }
        });
        this.props.actions.getSupervisorModelRevisionHistory({
          revision_id: revision_object.revision_id
        });
      });
  }

  handleRefreshPage = async () => {
    await this.props.actions.getPeriodsList();
    await this.props.actions.getModelsList();
  }

  handleOnChangeAllRevisionsListFilters = (event) => {
    let path = event.currentTarget.dataset.path;
    let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    let allRevisionsListFiltersNew = JavascriptUtilsTooling.deepCopy(this.state.allRevisionsListFilters);
    allRevisionsListFiltersNew[path] = value;
    this.setState({
      allRevisionsListFilters: allRevisionsListFiltersNew,
    });
    let queryParams = this.getAllRevisionsListQueryParams(this.state.dataFilters.periodIdSelected);
    queryParams[path] = value;
    this.props.actions.getAllRevisionsList(queryParams);
  }

  handleModelRevisionRowClick = (event) => {
    let modelRevision = JSON.parse(event.currentTarget.dataset.entitydata);
    let allRevisionsListFiltersNew = JavascriptUtilsTooling.deepCopy(this.state.allRevisionsListFilters);
    allRevisionsListFiltersNew["model_revisions_filter"] = modelRevision.id;
    this.setState({
      allRevisionsListFilters: allRevisionsListFiltersNew,
    });
    let queryParams = this.getAllRevisionsListQueryParams(this.state.dataFilters.periodIdSelected);
    queryParams["model_revisions_filter"] = modelRevision.id;
    this.props.actions.getAllRevisionsList(queryParams);
  };

  render() {
    var loadingView = (this.props.periodsList.firstLoading || this.props.periodsList.loading) ||
      (this.props.modelsList.firstLoading || this.props.modelsList.loading) || (
      (this.props.supervisorsRevisionsListByModel.firstLoading || this.props.allSupervisorsRevisionsList.firstLoading) && 
      this.props.periodsList.status == 200 && this.props.periodsList.data.length>0);
    var errorLoadingView = (this.props.periodsList.status !== null && this.props.periodsList.status !== 200) || 
      (this.props.supervisorsRevisionsListByModel.status !== null && this.props.supervisorsRevisionsListByModel.status !== 200) || 
      (this.props.allSupervisorsRevisionsList.status !== null && this.props.allSupervisorsRevisionsList.status !== 200) || 
      (this.props.modelsList.status !== null && this.props.modelsList.status !== 200);
    var noPeriodsCreated = this.props.periodsList.status == 200 && this.props.periodsList.data.length==0;

    return (
      <section className="dashboard_content_inner_view entity_admin_container supervisors_admin_revision_panel_container">
        {(!loadingView) && (  
          <i 
            className={"fas fa-sync top_refresh_button"}
            onClick={this.handleRefreshPage}
          />
        )}
        {
          loadingView ? (<FullScreenGlassLoading/>) :
          noPeriodsCreated ? (
            <section className={"supervisors_admin_revision_panel_no_period_wrapper"}>
              <div className="supervisors_admin_revision_panel_container_data_section">
                <Header/>
                <div className="no_period_selected_wrapper">
                  {intl.formatMessage({ id: "common.noPeriodCreated" })}
                </div>
              </div>
            </section>            
          ) :
          errorLoadingView ? (<ErrorLoadingView/>) :
          (
            <section className={"left_filter_fixed_section_parent" + (this.state.filtersCollapse ? " left_filter_fixed_section_parent_collapse" : "")}>
              <div className="left_filter_fixed_section">
                <Filters
                  onChangePeriod={this.handleOnChangePeriod}
                  periodsData={this.props.periodsList.data}
                  onChangeFilter={this.handleOnChangeDataFilters}
                  filterValues={this.state.dataFilters}
                  modelsData={this.props.modelsFilter.data}
                  modelsLoading={this.props.modelsFilter.loading}
                  modelsFetchAction={this.handleFetchFilterModels}
                  disabledPeriodSelector={this.props.fixedPeriodId!=""}
                  handleShowGenerateRevisionsConfirmPopup={this.handleShowGenerateRevisionsConfirmPopup}
                  loadingRevisionsGenerationButton={this.props.generateRevisions.loading}
                  handleShowSendMailsConfirmPopup={this.handleShowSendMailsConfirmPopup}
                  loadingSendMailsButton={this.props.sendMails.loading}
                />
                <div className="left_filter_fixed_section_collapse_component" onClick={this.handleFiltersCollapse}>
                  <i className={"fas "+ (this.state.filtersCollapse ? "fa-angle-right" : "fa-angle-left")}/>
                </div>
              </div>
              <div className="left_filter_right_section supervisors_admin_revision_panel_container_data_section small_table_components">
                <Header />
                <EntityTable
                  entityTableDescriptor={TableDescriptors.supervisorsRevisionsListByModel}
                  data={this.props.supervisorsRevisionsListByModel.data}
                  loading={this.props.supervisorsRevisionsListByModel.loading}
                  page={this.props.supervisorsRevisionsListByModel.page}
                  totalPages={this.props.supervisorsRevisionsListByModel.totalPages}
                  totalRecords={this.props.supervisorsRevisionsListByModel.totalRecords}
                  fetchListChangePage={this.fetchSupervisorsRevisionsListByModelNextPage}
                  handleRowClick={this.handleModelRevisionRowClick}
                  noSelectedText={intl.formatMessage({ id: "supervisorsAdminRevisionPanel.noActiveRevisions"})}
                  colorConfig={[{
                    color: "green",
                    column: "approval_status",
                    value: Constants.supervisorsAdmin.modelRevisionStatus.APPROVED
                  },{
                    color: "red",
                    column: "approval_status",
                    value: Constants.supervisorsAdmin.modelRevisionStatus.REJECTED
                  },{
                    color: "yellow",
                    column: "approval_status",
                    value: Constants.supervisorsAdmin.modelRevisionStatus.INCOMPLETE
                  }]}
                />
                <RevisionsHeader
                  modelsData={this.props.modelsList.data}
                  filterValues={this.state.allRevisionsListFilters}
                  onChangeFilter={this.handleOnChangeAllRevisionsListFilters}
                />
                <EntityTable
                  entityTableDescriptor={TableDescriptors.allSupervisorsRevisionsList}
                  data={this.props.allSupervisorsRevisionsList.data}
                  loading={this.props.allSupervisorsRevisionsList.loading}
                  page={this.props.allSupervisorsRevisionsList.page}
                  totalPages={this.props.allSupervisorsRevisionsList.totalPages}
                  totalRecords={this.props.allSupervisorsRevisionsList.totalRecords}
                  fetchListChangePage={this.fetchAllRevisionsListNextPage}
                  noSelectedText={<FormattedMessage id={"supervisorsAdminRevisionPanel.noRevisionsHistory"}/>}
                  handleCustomActions={[this.handleDownloadRevision, this.handleShowActionPopup, this.handleViewActionsHistory]}
                  customActionsIcons={["file-excel", "edit", "clipboard-list"]}
                  customActionsTooltips={[
                    intl.formatMessage({ id: "supervisorsAdminRevisionPanel.downloadRevisionTooltip"}),
                    intl.formatMessage({ id: "supervisorRevisionPanel.revisionTooltip"}),
                    intl.formatMessage({ id: "supervisorsAdminRevisionPanel.actionsHistoryTooltip"})
                  ]}
                  colorConfig={[{
                    color: "green",
                    column: "revision_state",
                    value: Constants.supervisorsAdmin.revisionStatus.APPROVED
                  },{
                    color: "red",
                    column: "revision_state",
                    value: Constants.supervisorsAdmin.revisionStatus.REJECTED
                  },{
                    color: "yellow",
                    column: "revision_state",
                    value: Constants.supervisorsAdmin.revisionStatus.NOT_REVIEWED
                  }]}
                  className={"all_supervisors_revisions_list_table"}
                />
              </div>              
              <RevisionActionsHistoryPopup
                handleShowPopup={this.handleViewActionsHistory}                
                revisionActionsHistoryInfo={this.state.revisionActionsHistoryInfo}
                revisionActionsHistoryData={this.props.supervisorModelRevisionHistory.data}
                fullLoading={this.props.supervisorModelRevisionHistory.loading}
                popupState={this.state[popupIds.revisionActionsHistoryPopup]}
              />
              <GlassConfirmPopup
                confirmTitle={(<FormattedMessage 
                  id={"supervisorRevisionPanel.reviewActionConfirmTitle"}
                  values={{modelName: this.state.actionModelName}}
                />)}
                confirmText={(<FormattedMessage id={"supervisorRevisionPanel.revisionActionsStepTitle"}/>)}
                handleCancel={this.handleShowActionPopup}
                hideCancel={true}
                popupState={this.state[popupIds.setReviewStatePopup]}
                loading={this.props.setRevisionStatus.loading}
              >
                <SupervisorActions
                  handleActionButtons={this.handleShowActionConfirmPopup}
                  revisionState={this.state.actionRevisionState}
                />
              </GlassConfirmPopup>
              <GlassConfirmWithNotesPopup
                confirmTitle={(<FormattedMessage 
                  id={"supervisorRevisionPanel.reviewActionConfirmTitle"}
                  values={{modelName: this.state.actionModelName}}
                />)}
                confirmText={(<FormattedMessage id={"supervisorRevisionPanel.reviewActionConfirm"}/>)}
                handleConfirm={this.handleOnClickActionConfirm}
                handleCancel={this.handleShowActionConfirmPopup}
                popupState={this.state[popupIds.setReviewStateConfirmPopup]}
                loading={this.props.setRevisionStatus.loading}
                notesValue={this.state.actionNotes}
                notesLabelLocale={intl.formatMessage({ id:"supervisorRevisionPanel.reviewActionNotesLabel"})}
                handleOnChangeNotes={this.handleOnChangeActionNotes}
              />
              <GlassConfirmWithNotesPopup
                confirmTitle={(<FormattedMessage id={"supervisorsAdminRevisionPanel.generateRevisionsConfirmTitle"}/>)}
                confirmText={(<FormattedMessage id={"supervisorsAdminRevisionPanel.generateRevisionsConfirm"}/>)}
                handleConfirm={this.handleOnClickGenerateRevisionsConfirm}
                handleCancel={this.handleShowGenerateRevisionsConfirmPopup}
                popupState={this.state[popupIds.generateRevisionsConfirmPopup]}
                loading={this.props.generateRevisions.loading}
                notesValue={this.state.generateRevisionsNotes}
                notesLabelLocale={intl.formatMessage({ id:"supervisorsAdminRevisionPanel.generateRevisionsNotesLabel"})}
                handleOnChangeNotes={this.handleOnChangeGenerateRevisionsNotes}
              />
              <GlassConfirmWithNotesPopup
                confirmTitle={(<FormattedMessage id={"supervisorsAdminRevisionPanel.sendMailsConfirmTitle"}/>)}
                confirmText={(<FormattedMessage id={"supervisorsAdminRevisionPanel.sendMailsConfirm"}/>)}
                handleConfirm={this.handleOnClickSendMailsConfirm}
                handleCancel={this.handleShowSendMailsConfirmPopup}
                popupState={this.state[popupIds.sendMailsConfirmPopup]}
                loading={this.props.sendMails.loading}
                notesValue={this.state.sendMailsNotes}
                notesLabelLocale={intl.formatMessage({ id:"supervisorsAdminRevisionPanel.sendMailsNotesLabel"})}
                handleOnChangeNotes={this.handleOnChangeSendMailsNotes}
              />
            </section>
          )
        }
      </section>
    );
  }
}

const mapStateToProps = state => ({
  downloadRevision: state.reducer.supervisorsAdminRevisionPanel.downloadRevision,
  setRevisionStatus: state.reducer.supervisorsAdminRevisionPanel.setRevisionStatus,
  handleNotificationDetailPopupReference: state.reducer.dashboard.handleNotificationDetailPopupReference,
  supervisorsRevisionsListByModel: state.reducer.supervisorsAdminRevisionPanel.supervisorsRevisionsListByModel,
  allSupervisorsRevisionsList: state.reducer.supervisorsAdminRevisionPanel.allSupervisorsRevisionsList,
  supervisorModelRevisionHistory: state.reducer.supervisorsAdminRevisionPanel.supervisorModelRevisionHistory,
  periodId: state.reducer.supervisorsAdminRevisionPanel.periodId,
  fixedPeriodId: state.reducer.dashboard.fixedPeriodId,
  periodsList: state.reducer.supervisorsAdminRevisionPanel.periodsList,
  sendMails: state.reducer.supervisorsAdminRevisionPanel.sendMails,  
  generateRevisions: state.reducer.supervisorsAdminRevisionPanel.generateRevisions,
  modelsFilter: state.reducer.supervisorsAdminRevisionPanel.modelsFilter,
  modelsList: state.reducer.supervisorsAdminRevisionPanel.modelsList,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(supervisorsAdminRevisionPanelActions, dispatch),
  dashboardActions: bindActionCreators(dashboardActions, dispatch),
});

SupervisorsAdminRevisionPanel.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SupervisorsAdminRevisionPanel);



// WEBPACK FOOTER //
// ./source/client/containers/supervisorsAdminRevisionPanel/index.jsx